import * as React from 'react';
import CourtReporting939DataCore from '../CourtReporting/CourtReporting939DataCore';
import { UserRoleEnum } from '../../redux/UserSlice';



const CourtReporting939CI = (props: any) => {
    return (
        <React.Fragment>
            <CourtReporting939DataCore userRole={UserRoleEnum.EntityUser} dataSection={"CourtInnovations"} />
        </React.Fragment>
    );
}

export default CourtReporting939CI;